/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToRem, pxToEm, mediaQuery, replacePXinStringWithEM } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION: COLOR SCHEME SECTION : STYLES --------------- ++++++++++ */
export default theme => ({
  colorschemesection: {
    zIndex: 1,
    position: 'relative',
    marginTop: pxToEm(16),
    marginBottom: pxToEm(16),
    '& .sectiondescription' : {
      '& .colorspreview': {
        height: pxToEm(32),
        display: 'flex',
			  alignItems: 'center',
        '& .swatch': {
          borderRadius: pxToEm(16),
          width: pxToEm(32),
          height: pxToEm(32),
          marginRight: pxToEm(3),
          border: replacePXinStringWithEM('2px solid rgb(238, 242, 246)'),
          position: 'relative'
        }
      }
    },
    '& .collapsable.opened': {
      maxHeight: pxToRem(3000),
      overflow: 'visible !important',
      '& .innerWrap': {
        display: 'flex',
        [mediaQuery.customizeThinnest]: {
          display: 'block'
        }
      }
    },
    '& .collapsable': {
      '& .innerWrap': {
        display: 'flex',
        [mediaQuery.customizeThinnest]: {
          display: 'block'
        }
      }
    },
    '& .colorschemeconfig':{
      marginRight: pxToEm(8),
      maxWidth: pxToEm(480),
      [mediaQuery.customizeThinnest]: {
        marginRight: 0,
        marginBottom: pxToEm(8),
        maxWidth: 'none'
      },
      '& .sectioncard':{
        padding: replacePXinStringWithEM('32px 24px 32px 24px'),
        [mediaQuery.customizeThinnest]: {
          textAlign: 'center'
        }
      },
      '& .content': {
        '& .colorpickercolumn': {
          margin: replacePXinStringWithEM('16px 80px 0px 80px'),
          display: 'block',
          width: '100%',
          [mediaQuery.customizeThinnest]: {
            margin: 'auto',
            marginTop: pxToEm(16)
          },
          '& .colorpicker': {
            marginBottom: pxToEm(16),
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            marginBottom: pxToEm(16),
            '& .colorpickerlabel': {
              '& .reset': {
                [mediaQuery.customizeThinnest]: {
                  marginRight: 'auto'
                }
              }
            },
            '& .field': {
              [mediaQuery.customizeThinnest]: {
                width: 'auto'
              },
              '& .formelement': {
                [mediaQuery.customizeThinnest]: {
                  maxWidth: pxToEm(175)
                },
              }
            },
            '&:last-child': {
              marginBottom: 0
            }
          }
        }
      }
    },
    '& .colorschemepreview':{
      marginTop: 0,
      cursor: 'default',
      '& .sectioncard':{
        maxWidth: pxToEm(364),
        padding: pxToEm(8),
        [mediaQuery.customizeThinnest]: {
          maxWidth: 'none',
          width: '100%'
        },
      },
      '& .previewcontainer': {
        maxWidth: pxToEm(348),
        width: '100%',
        [mediaQuery.customizeThinnest]: {
          maxWidth: pxToEm(1048)
        },
        borderRadius: pxToEm(12),
        padding: replacePXinStringWithEM('24px 40px 24px 40px'),
        [mediaQuery.customizeThinnest]: {
          textAlign: 'center',
          padding: replacePXinStringWithEM('24px 16px 24px 16px')
        },
        '& .previewheader': {
          height: pxToEm(28),
          display: 'flex',
          '& span': {
            fontSize: pxToEm(24),
            fontWeight: 'bold',
            color: theme.color.supporting.dark.swatch,
            marginRight: 'auto'
          },
          '& img': {
            width: pxToEm(56)
          }
        },
        '& .commentfield': {
          marginTop: pxToEm(32),
          height: pxToEm(52),
          borderRadius: pxToEm(4),
          padding: pxToEm(16),
          '& span': {
            lineHeight: pxToEm(20),
            fontSize: pxToEm(15),
            fontWeight: '500'
          }
        },
        '& .navbarcontainer': {
          marginTop: pxToEm(32),
          lineHeight: pxToEm(16),
          display: 'flex',
          fontSize: pxToEm(13),
          fontWeight: '600',
          '& .comments': {
            marginRight: 'auto'
          },
          '& .community': {
            marginRight: pxToEm(24)
          }
        },
        '& .navbarunderline': {
          width: pxToEm(70),
          height: pxToEm(2),
          borderRadius: 0,
          marginTop: pxToEm(6)
        }
      },
      '& .sortbycontainer': {
        marginTop: pxToEm(24),
        lineHeight: pxToEm(16),
        display: 'flex',
        fontSize: pxToEm(13),
        fontWeight: '500',
        '& .popular': {
          marginLeft: pxToEm(4),
          fontWeight: '600',
          '& span':  {
            marginRight: pxToEm(7)
          }
        }
      },
      '& .commentsection': {
        marginTop: pxToEm(24),
        display: 'block',
        '& .userinfo': {
          display: 'flex',
          '& img': {
            width: pxToEm(40),
            height: pxToEm(40),
            borderRadius: '50%',
            marginTop: pxToEm(16)
          },
          '& .nameanddate': {
            display: 'block',
            margin: replacePXinStringWithEM('16px 0px 0px 16px'),
            marginRight: 'auto',
            textAlign: 'left',
            '& .name': {
              display: 'flex',
              '& span': {
                fontSize: pxToEm(15),
                lineHeight: pxToEm(20),
                [mediaQuery.medium]: {
                  width: 'auto'
                },
              },
              '& .diamond': {
                height: pxToEm(12),
                transform: 'rotate(45deg)',
                width: pxToEm(12),
                fontSize: pxToEm(12),
                marginTop: pxToEm(9),
                marginLeft: pxToEm(8)
              }
            },
            '& span': {
              marginTop: pxToEm(4),
              lineHeight: pxToEm(16),
              fontSize: pxToEm(13),
              fontWeight: '500'
            }
          },
          '& .promotedbutton': {
            width: pxToEm(97),
            height: pxToEm(24),
            borderRadius: pxToEm(12),
            marginTop: pxToEm(8),
            display: 'flex',
            '& .promoted': {
              width: '100%',
              '& span': {
                lineHeight: pxToEm(12),
                height: pxToEm(12),
                fontWeight: 'bold',
                fontSize: pxToEm(11),
                margin: replacePXinStringWithEM('5.5px 6px 6px 10px'),
                verticalAlign: 'text-top',
                letterSpacing: '0.5px'
              },
              '& svg': {
                height: pxToEm(12),
                width: pxToEm(12),
                transform: 'scaleX(-1)',
                margin: replacePXinStringWithEM('5.5px 6px 6px 0px')
              }
            }
          }
        },
        '& .comment': {
          fontSize: pxToEm(15),
          fontWeight: '500',
          lineHeight: pxToEm(20),
          marginTop: pxToEm(16),
          textAlign: 'left'
        },
        '& .reactionbar': {
          marginTop: pxToEm(16),
          display: 'flex',
          '& span': {
            fontSize: pxToEm(13),
            fontWeight: '500',
            margin: replacePXinStringWithEM('2px 0px 2px 0px')
          },
          '& svg': {
            height: pxToEm(20),
            width: pxToEm(20)
          }
        },
        '& .morecommentfield': {
          marginTop: pxToEm(32),
          height: pxToEm(44),
          borderRadius: pxToEm(4),
          paddingTop: pxToEm(12),
          textAlign: 'center',
          '& span': {
            lineHeight: pxToEm(16),
            fontSize: pxToEm(13),
            fontWeight: '600'
          }
        },
      }
      
    }
  }
});
